import "./App.css";
import { ReduxStoreProvider } from "./components/ReduxStoreProvider";
import MainRouter from "./pages/router/RouterMain";
import MainThemeProvider from "./theme/ThemeProvider";
import { ProjectProvider } from "./pages/AccountPage/components/context/ProjectContext";
import "@ant-design/v5-patch-for-react-19";
import BootstrapSystem from "./pages/Bootstrap";

function AppContent() {
  return <MainRouter />;
}

function App() {
  return (
    <MainThemeProvider>
      <ProjectProvider>
        <ReduxStoreProvider>
          <BootstrapSystem>
            <AppContent />
          </BootstrapSystem>
        </ReduxStoreProvider>
      </ProjectProvider>
    </MainThemeProvider>
  );
}

export default App;
